import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const Slider = ({ values, autoPlay }) => {
    const CarouselSettings = {
      showStatus: false,
      showThumbs: false,
      infiniteLoop: true,
      showIndicators: values.lengh > 1,
      swipeScrollTolerance: 15,
      autoPlay: autoPlay, 
    };
    return (
      <Carousel {...CarouselSettings}>
        {values.map((value, index) => (
          <a className="slider__link" href={value.url ? (
            value.url
            ) : (
              value.texturl
            )} 
            key={`figure${index}`}>
            <div className="slider-wrapper"> 
              <img className={`slider__image ${value.mobileimage ? "desktop" : "mobile desktop"}`} src={value.image}/>
              <img className="slider__image mobile" src={value.mobileimage}/>
                {/* TODO: Remove or fix STR-13-Scaling-mobile*/}
                {/* Nedan byter bild korrekt, men får inte till stylingen för att bilderna ska skala rätt */}   
                {/* <picture>
                  <source className="slider__image" media="(min-width: 481px)" srcset={value.image} />
                  <source className="slider__image" media="(max-width: 480px)" srcset={value.mobileimage} />
                  <img src={value.image} alt="IfItDoesntMatchAnyMedia" />
                </picture> */}
                <div className={'text-wrapper' + ' ' + value.textplacement}>
                  {value.text  && 
                    <h2 className={'slider__text' + ' ' + value.textsize} style={{"color": value.color}}>{value.text}</h2>
                  }
                  {value.textsection &&
                    <div className="slider__text-section" style={{"color": value.color}} dangerouslySetInnerHTML={{__html: value.textsection}}></div>          
                  }
                </div>
              </div>
          </a>
        ))}
      </Carousel>
    );
  };
  

export default Slider;